import type { ContentScopedProps } from '../../content.types'
import { ContentActionsTextVariants } from './content-actions-text-styles'

type ContentActionsTextProps = {
  children: React.ReactNode
}
export function ContentActionsText(props: ContentActionsTextProps) {
  const { children } = props as ContentScopedProps<ContentActionsTextProps>

  return (
    <div
      className={ContentActionsTextVariants()}
      data-testid="content-actions-text"
    >
      {children}
    </div>
  )
}
